import React from "react";

import "./styles.scss";

const CardLayout = ({ children }) => {
  return <section className={"card-layout"}>{children}</section>;
};
export default CardLayout;
